import React from "react";
import { EcpTeachercourseEnrollmentsSplitview } from "../components/splitviews/ecp-teachercourse-enrollments-splitview";

export function EcpDepartmentChairDashboardPage(props) {
  return <EcpTeachercourseEnrollmentsSplitview {...props} />;
}
